import { AccountNavigationView } from '@playbooks/components/account/account-navigation-view';

const AccountDropCommunity = ({ onPrev }) => (
	<AccountNavigationView
		title='Community'
		onBack={onPrev}
		items={[
			{
				icon: 'github',
				iconType: 'fab',
				href: 'https://github.com/playbooks-hq',
				label: 'GitHub',
				external: true,
			},
			{
				icon: 'x-twitter',
				iconType: 'fab',
				href: 'https://x.com/playbooks_hq',
				label: 'Twitter',
				external: true,
			},
			{
				icon: 'youtube',
				iconType: 'fab',
				href: 'https://www.youtube.com/@playbookshq',
				label: 'YouTube',
				external: true,
			},
			{
				icon: 'slack',
				iconType: 'fab',
				href: 'https://slack.playbooks.ai',
				label: 'Slack',
				external: true,
			},
		]}
	/>
);
export { AccountDropCommunity };
